import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatPrice } from "@/lib/api";

function Countdown({ end }) {
  const [t, setT] = useState(timeLeft(end));
  useEffect(() => { const id = setInterval(() => setT(timeLeft(end)), 1000); return () => clearInterval(id); }, [end]);
  if (t.ended) return <span className="text-xs tracking-[0.2em] uppercase" style={{ color: "var(--ja-error)" }}>Ended</span>;
  return <span className="text-xs tracking-[0.2em] uppercase" style={{ color: "var(--ja-gold)" }}>{t.d}d {t.h}h {t.m}m {t.s}s</span>;
}
function timeLeft(iso) {
  const ms = new Date(iso) - new Date();
  if (ms <= 0) return { ended: true };
  const s = Math.floor(ms / 1000);
  return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60, ended: false };
}

export default function Auctions() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/auctions").then((r) => setItems(r.data)); }, []);

  return (
    <div className="ja-container py-16 md:py-24" data-testid="auctions-page">
      <div className="text-center mb-16">
        <p className="ja-overline">Private Auctions</p>
        <h1 className="ja-serif text-5xl md:text-6xl mt-3 tracking-tight">Rare. Bid. Yours.</h1>
        <p className="mt-4 max-w-xl mx-auto text-sm" style={{ color: "var(--ja-muted)" }}>One-of-one pieces, released to our highest bidders. Live, transparent, and timed.</p>
      </div>
      {items.length === 0 ? (
        <div className="text-center py-20 border-t" style={{ borderColor: "var(--ja-border)" }}>
          <p className="ja-serif text-2xl">No live auctions at this moment.</p>
          <p className="mt-3 text-sm" style={{ color: "var(--ja-muted)" }}>Subscribe to be notified when the next collection drops.</p>
        </div>
      ) : (
        <div className="grid md:grid-cols-3 gap-x-6 gap-y-12">
          {items.map((a) => (
            <Link key={a.id} to={`/auctions/${a.id}`} className="group block" data-testid={`auction-card-${a.id}`}>
              <div className="aspect-[4/5] overflow-hidden bg-white">
                <img src={a.image} alt={a.title} className="w-full h-full object-cover ja-hover-img" loading="lazy" />
              </div>
              <div className="pt-5">
                <p className="ja-overline" style={{ color: "var(--ja-muted)" }}>{a.sku}</p>
                <p className="ja-serif text-xl mt-1">{a.title}</p>
                <div className="mt-3 flex justify-between items-center text-sm">
                  <span>Current Bid: <strong>{formatPrice(a.current_bid)}</strong></span>
                  <Countdown end={a.end_time} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
